export const NOT_FOUND = 'Not Found';

export const UNABLE_TO_AUTHENTICATE = 'Unable to authenticate';
